/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Breadcrumb from "../../../component/breadcrumb";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid, ButtonGroup } from "@mui/material";
import { UsersIcon, DetailView, ListView } from "../../../component/icons/icons";
import Button from "../../../component/button";
import { withNavigation } from "../../../helper/withNavigation";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import SubscriptionsTable from "./subscriptionsTable";
import Loader from "../../../component/loader";

// Manage order page class
class Subscriptions extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [{ title: this.props.t("SUBSCRIPTIONS"), url: "/subscriptions" }],
    display: false,
    isMobile: false,
    showCustomerList: false,
    tenantList: [],
    tenant: "",
    subscriptionView: '',

    subsFilters: {
      productName: "",
      subscriptionId: "",
      orderId: "",
    },
    subsHistoryPage: 1,
    subsHistoryPerPage: 10,
    subsHistoryStartRecord: 1,
    subscriptionRowsPerPage: 10,
    sortOrderSubs: "DESC",
    sortBySubs: "subscriptionId",
    searchIdentifierValues: [],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    const subscriptionView = localStorage.getItem("subscriptionView");

    if (this.props.providerType === "SOLUTION_PROVIDER") {
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
        {},
      )
        .then((res) => {
          let list = res.data.tenants;
          var selectedSalesChannel = localStorage.getItem(
            "selectedSalesChannel",
          );
          this.setState(
            {
              tenantList: list,
              tenant:
                this.props.parentTenantId ||
                selectedSalesChannel ||
                (list && list.length > 0 ? list[0].tenantId : ""),
            },
            () => {
              localStorage.setItem(
                "selectedSalesChannel",
                this.state.tenant,
              );
              if (subscriptionView === null) {
                this.setState({
                  subscriptionView: 'detail'
                });
                // this.getCustomersHierarchy();
              } else {
                this.setState({
                  subscriptionView
                });
                this.getSubscriptionsList();
              }
            },
          );
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      if (subscriptionView === null) {
        this.setState({
          subscriptionView: 'detail'
        });
      } else {
        this.setState({
          subscriptionView
        });
        this.getSubscriptionsList();
      }
    }
  }
  getSubscriptionsList = () => {
    this.setState({
      loading: true,
    })
    let pageOptions = {
      batchSize: this.state.subsHistoryPerPage || 10,
      startRecord: this.state.subsHistoryStartRecord || 1,
    };

    let filter = "&orderId=";
    if (this.state.orderId !== null && this.state.orderId !== "") {
      filter = filter + this.state.orderId;
    }

    let data = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      data.tenantId = this.state.tenant;
    }

    let encodedSearchIdentifierValues = '';
    if (Array.isArray(this.state.searchIdentifierValues) && this.state.searchIdentifierValues.length > 0) {
      encodedSearchIdentifierValues = this.toBase64Json(this.state.searchIdentifierValues);
    }
    BusApiCall('GET', `${constants.busV44UrlPublic}/subscriptions?sortBy=${this.state.sortBySubs}&sortOrder=${this.state.sortOrderSubs}&productName=${this.state.subsFilters.productName}&subscriptionId=${this.state.subsFilters.subscriptionId}&orderId=${this.state.subsFilters.orderId}&jsonData=${encodedSearchIdentifierValues}`, data, pageOptions).then(res => {
      this.setState({
        subscriptionData: res.data.subscriptions || [],

        totalSubscriptionCount: +res.headers["x-total-count"],
        loading: false,
        searchingSubscriptions: false,
      });
    })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, searchingSubscriptions: false });
      });
  };

  updateSubsSorting = (by) => {
    if (by === this.state.sortBySubs) {
      this.setState(
        {
          loading: true,
          sortOrderSubs: this.state.sortOrderSubs === "DESC" ? "ASC" : "DESC",
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getSubscriptionsList();
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortBySubs: by,
          sortOrderSubs: "ASC",
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getSubscriptionsList();
        },
      );
    }
  };

  updateSubsHistoryPerPageRows = (event) => {
    this.setState(
      {
        loading: true,
        subsHistoryPage: 1,
        subsHistoryPerPage: event.target.value,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getSubscriptionsList();
      },
    );
  };

  onSubsHistoryPageChange = (e, page) => {
    this.setState(
      {
        loading: true,
        subsHistoryPage: page,
        subsHistoryStartRecord: this.state.subsHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getSubscriptionsList();
      },
    );
  };

  onChangeSubsInput = (e) => {
    var data = { ...this.state.subsFilters };
    data[e.target.name] = e.target.value;
    this.setState({
      subsFilters: data,
    });
  };
  onSearchKeyDownSubsInput = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          loading: true,
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getSubscriptionsList();
        },
      );
    }
  };

  handleSearchIdentifierChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => {
      const arr = Array.isArray(prev.searchIdentifierValues) ? [...prev.searchIdentifierValues] : [];
      const idx = arr.findIndex(item => item.key === name);
      if (value === '' || value == null) {
        if (idx > -1) arr.splice(idx, 1);
      } else if (idx > -1) {
        arr[idx] = { ...arr[idx], value };
      } else {
        arr.push({ key: name, value });
      }
      return { searchIdentifierValues: arr };
    });
  };

  filterSubsTable = () => {
    this.setState(
      {
        loading: true,
        subsHistoryPage: 1,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getSubscriptionsList();
      },
    );
  };

  clearSubsTableSearch = () => {
    this.setState(
      {
        subsFilters: {
          productName: "",
          subscriptionId: "",
          orderId: "",
        },
        searchIdentifierValues: [],
        loading: true,
        subsHistoryPage: 1,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getSubscriptionsList();
      },
    );
  };

  openSubscription = (index) => {
    let subscriptions = [...this.state.subscriptionData];
    if (
      !subscriptions[index].expand &&
      !subscriptions[index].addiotinalDetails
    ) {
      subscriptions[index].expand = !subscriptions[index].expand;
      this.setState({
        loading: true,
      });
      let jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = this.state.tenant;
      }
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/subscriptions/${subscriptions[index].subscriptionId}`,
        jsonData,
      )
        .then((res) => {
          subscriptions[index].addiotinalDetails = res.data;
          this.setState({
            subscriptionData: subscriptions,
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            subscriptionData: subscriptions,
            loading: false,
          });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      subscriptions[index].expand = !subscriptions[index].expand;
      this.setState({
        subscriptionData: subscriptions,
      });
    }
    // subscriptions[index].expand = !subscriptions[index].expand;
    // this.setState({
    //     subscriptionData: subscriptions
    // })
  };

  toBase64Json(obj) {
    const json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json)));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  changeRoute = (data) => {
    this.props.router.navigate("/newOrder", { state: data });
  };

  goToQuote = (id, type) => {
    if (type && type === "order") {
      this.props.router.navigate({
        pathname: "/order/" + id,
      });
    } else {
      this.props.router.navigate({
        pathname: "/quote/" + id,
      });
    }
  };
  toggleShowAllSubscriptions = (viewType) => {
    this.setState({
      subscriptionView: viewType
    }, () => {
      if (viewType === 'list') {
        this.getSubscriptionsList();
      }
    });
    localStorage.setItem("subscriptionView", viewType);
  }
  onChangeTenant = (e) => {
    this.setState({
      tenant: e.target.value,
    })
  }


  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {isMobile && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
        <main>
          <Grid container spacing={1}>
            <Grid
              item
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
                marginBottom: "1rem",
              }}
              size={{
                xs: 12,
                md: 12,
              }}
            >
              {isMobile && (
                <Button
                  className="buttonSecondary"
                  onClick={this.toggleShowCustomerList}
                >
                  <span
                    style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                  >
                    <UsersIcon />
                  </span>
                  {t("SHOW_CUSTOMER_LIST")}
                </Button>
              )}
              <ButtonGroup variant="outlined">
                {/* DETAIL VIEW button */}
                <span
                  className={`buttonGroup ${this.state.subscriptionView === 'detail' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllSubscriptions("detail")}
                  style={{
                    backgroundColor: this.state.subscriptionView === 'detail'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.subscriptionView === 'detail' ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("DETAIL_VIEW")}
                  </span>
                  <DetailView />
                </span>
                {/* LIST VIEW button */}
                <span
                  className={`buttonGroup ${this.state.subscriptionView === 'list' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllSubscriptions("list")}
                  style={{
                    backgroundColor: this.state.subscriptionView === 'list'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.subscriptionView === 'list' ? "white" : "inherit",
                  }}
                >
                  <span>{this.props.t("LIST_VIEW")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>

          {this.state.subscriptionView === 'detail' ?
            <ManageCustomersHierarchy
              screen="subscriptions"
              changeRoute={this.changeRoute}
              goToQuote={this.goToQuote}
              isMobile={isMobile}
              showCustomerList={showCustomerList}
              toggleShowCustomerList={this.toggleShowCustomerList}
            />
            :
            <>
              <SubscriptionsTable
                totalSubscriptionCount={
                  this.state
                    .totalSubscriptionCount
                }
                subsHistoryPage={
                  this.state.subsHistoryPage
                }
                subsHistoryPerPage={
                  this.state
                    .subsHistoryPerPage
                }
                onSubsHistoryPageChange={
                  this
                    .onSubsHistoryPageChange
                }
                updateSubsHistoryPerPageRows={
                  this
                    .updateSubsHistoryPerPageRows
                }
                updateSubsSorting={
                  this.updateSubsSorting
                }
                subscriptions={
                  this.state
                    .subscriptionData
                }
                isChild={
                  this.state.showChildItem
                    ? true
                    : false
                }
                customerDetails={
                  this.state.customerDetails
                }
                childItemDetails={
                  this.state
                    .childItemDetails
                }
                openSubscription={
                  this.openSubscription
                }
                tenantId={this.state.tenant}
                getCustomerSubscriptions={
                  this
                    .getCustomerSubscriptions
                }
                searchingSubscriptions={
                  this.state
                    .searchingSubscriptions
                }
                changeRoute={
                  this.props.changeRoute
                }
                sortBySubs={
                  this.state.sortBySubs
                }
                sortOrderSubs={
                  this.state.sortOrderSubs
                }
                subsFilters={
                  this.state.subsFilters
                }
                clearSubsTableSearch={
                  this.clearSubsTableSearch
                }
                filterSubsTable={
                  this.filterSubsTable
                }
                onChangeSubsInput={
                  this.onChangeSubsInput
                }
                onSearchKeyDownSubsInput={
                  this
                    .onSearchKeyDownSubsInput
                }
                goToQuote={
                  this.props.goToQuote
                }
                expandItemHistory={
                  this.expandItemHistory
                }
                handleSearchIdentifierChange={this.handleSearchIdentifierChange}
                searchIdentifierValues={this.state.searchIdentifierValues}

                screen={'listView'}
                tenantList={this.state.tenantList}
                onChangeTenant={this.onChangeTenant}
              />
            </>
          }
        </main>
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    showMyCustomers: state.auth.showMyCustomers,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Subscriptions)));
